<proffeo-ui-dialog [title]="'project-tags.add-tag-to-task' | translate">
  <div class="flex h-full w-full flex-grow flex-col">
    <div class="flex flex-col items-center justify-center">
      <proffeo-label class="mb-3">{{ 'project-tags.select-tag' | translate }}:</proffeo-label>
      @for (tag of tags(); track tag?.id) {
        <div
          (click)="onTagToggle(tag.id)"
          class="mb-2 flex w-full items-center truncate text-nowrap gap-2 cursor-pointer hover:bg-proffeo-surface-muted rounded-2xl px-2"
        >
          <mat-checkbox [checked]="isTagSelected(tag.id)"></mat-checkbox>
          <proffeo-tag
            [tag]="tag"
            class="cursor-pointer"
          ></proffeo-tag>
          <mat-icon
            fontIcon="edit"
            click
            editTag
            tag
            event
            class="materials-symbols-outlined cursor-pointer ml-auto icon-md icon-muted"
          />
        </div>
      }
      <div class="mb-3 mt-2 flex w-full items-center">
        <proffeo-ui-button
          (clicked)="addTag()"
          variant="accent"
          text="project-tags.add-project-tag"
        ></proffeo-ui-button>
      </div>
    </div>
  </div>

  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      mat-dialog-close
      text="close"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="handleSaveClick()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
